import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import ProgressBar from './_progress-bar.js'
import DateTime from './_date-time.js'
import BonusItems from './_bonus-items.js'

export default {
  name: 'ActiveBonuses',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
      },
    },
    shouldShowRemainingAmount: true,
    header: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    headerTextWrapper: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '16px 0 0 8px',
          height: '24px',
          alignItems: 'center',
        },
      },
    },
    headerText: {
      configSet: Text,
      configValues: {},
    },
    progressBar: {
      configSet: ProgressBar,
      configValues: {},
    },
    remainingProgressVisibilityLimit: 20,
    noBonusesCard: {
      configSet: FlexPane,
      configValues: {},
    },
    bonusItemsNotAvailable: {
      configSet: Text,
      configValues: {
        container: {
          padding: '16px 0 16px 8px',
        },
      },
    },
    campaignExpireDateTimeFormat: {
      configSet: DateTime,
      configValues: {
        format: 'FULL_DATE_TIME',
      },
    },
    bonusItems: {
      configSet: BonusItems,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
